import type { ReactNode } from "react";
import { RadioGroup } from "src/design-system/components/Radio/RadioGroup";
import { Radio } from "src/design-system/components/Radio/Radio";
import { Icon } from "src/design-system/components/Icon/Icon";

const defaultGroup = "code-for-default-group";

type Option = {
  value: string;
  label: string;
  subtitle?: string | ReactNode;
  icon?: ReactNode;
  group?: string;
};

type RadioGroupListProps = {
  options: Option[];
  selectedValue: string;
  onChange: (value: string) => void;
  name: string;
  groups?: string[];
};

export function RadioGroupList(props: RadioGroupListProps) {
  const { name, options, selectedValue, onChange, groups = [] } = props;

  // create an object with keys for each group so we can use it to separate options into groups
  const initialGroups = groups.reduce(
    (acc, key) => ({ ...acc, [key]: [] }),
    {},
  );
  // separate options into groups
  const optionsGrouped = options.reduce(
    (acc, option) => {
      const group = option.group || defaultGroup;
      if (!acc[group]) {
        acc[group] = [];
      }
      acc[group].push(option);
      return acc;
    },
    initialGroups as Record<string, Option[]>,
  );

  return (
    <div className="flex flex-col gap-4">
      {Object.keys(optionsGrouped).map((group) => {
        const options = optionsGrouped[group];
        return (
          <>
            {group !== defaultGroup && (
              <h3 className="text-lg font-semibold">{group}</h3>
            )}
            <RadioGroup
              className="grid grid-flow-row grid-cols-3 gap-4"
              key={group}
              name={name}
              value={selectedValue}
              onChange={(value) => onChange(value)}
            >
              {options.map((option) => (
                <Radio
                  key={option.value}
                  value={option.value}
                  radioLabel={option.label}
                >
                  {option.subtitle && (
                    <span className="text-sm text-gray-500">
                      {option.subtitle}
                    </span>
                  )}
                  <Icon>{option.icon}</Icon>
                </Radio>
              ))}
            </RadioGroup>
          </>
        );
      })}
    </div>
  );
}
